// +-------------------------------------------------------------------+
// | IMPORTANT!!!!                                                     |
// | we import babel-polyfill inside of the entry file                 |
// | this way babel can work it's magic for polyfilling older browsers |
import 'babel-polyfill';
// --------------------------------------------------------------------+
import fetchHeaders from 'fetch-headers/headers-es5.min';
import 'whatwg-fetch'; // fetch polyfill for IE

// polyfill for undefined headers with apollo-link-rest
// https://github.com/apollographql/apollo-link-rest/issues/41
global.Headers = global.Headers || fetchHeaders;

if (!global.Headers.prototype.forEach) {
  global.Headers.prototype.forEach = fn => {
    [this].forEach(fn);
  };
}

if (typeof document === 'undefined') {
  global.navigator = { userAgent: 'all' };
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/utils/polyfill.js